<template>
  <div class="px-6 py-4 text-left modal-content">
    <!--Title-->
    <div class="flex items-center justify-between pb-3">
      <p class="text-2xl font-bold">Create new blog</p>
    </div>

    <!--Body-->
    <label class="block mt-1">
      <span class="text-sm text-gray-700 capitalize">title<span class="text-red-500">*</span></span>
      <input
        type="text"
        class="block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        v-model="blog.title"
      />
    </label>

    <label class="block">
      <span class="text-sm text-gray-700 capitalize">Slug<span class="text-red-500">*</span></span>
      <input
        type="text"
        class="block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        v-model="blog.slug"
      />
    </label>

    <label class="block">
      <span class="text-sm text-gray-700 capitalize">subtitle<span class="text-red-500">*</span></span>
      <input
        type="text"
        class="block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        v-model="blog.subtitle"
      />
    </label>

    <div class="relative">
      <span class="text-sm text-gray-700 capitalize">category<span class="text-red-500">*</span></span>
      <select
        class="block w-full h-full px-4 py-2 pr-8 mb-6 leading-tight text-gray-700 bg-white border border-gray-400 rounded-l appearance-none focus:outline-none focus:bg-white focus:border-gray-500 text-sm"
        v-model="blog.category_id"
      >
        <option v-for="category in categories" :key="category.id" :value="category.id" class="whitespace-nowrap">
          {{ category.name }}
        </option>
      </select>

      <div class="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none mt-6">
        <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>

    <!-- new editor. for more, please check on AppTest.vue -->
    <label class="block mb-6">
      <span class="text-sm text-gray-700 capitalize">Body<span class="text-red-500">*</span></span>
      <div id="sample">
        <editor
          v-model="content"
          licenseKey="gpl"
          tinymce-script-src="/tinymce/tinymce.min.js"
          :init="{
            height: 500,
            menubar: false,
            toolbar_mode: 'sliding',
            plugins: ['anchor', 'autolink', 'charmap', 'codesample', 'emoticons', 'image', 'link', 'lists', 'media', 'searchreplace', 'table', 'visualblocks', 'wordcount'],
            toolbar: 'undo redo | blocks | bold italic underline strikethrough | link image media table mergetags | align | numlist bullist',
            images_upload_handler: tinyMceImageUploader,
            block_formats: 'Paragraph=p;Heading 2=h2;Heading 3=h3;',
            media_alt_source: false,
            media_poster: false,
            forced_root_block: 'div',
            setup(editor) {
              editor.on('paste', (e) => {
                // e.preventDefault(); // Block paste
                onPaste();
              });
              // editor.on('drop', (e) => {
              //   e.preventDefault(); // Block drag-drop paste
              //   onPaste();
              // });
              editor.on('init', () => {
                const iframeContainer = editor.getContainer();
                iframeContainer.style.border = '1px solid #9ca3af';
                iframeContainer.style.borderRadius = '8px';
              });
            },
          }"
          class="mt-1 mb-6 border border-gray-900 rounded-md"
          contentType="html"
        />
      </div>
    </label>

    <div class="relative">
      <span class="text-sm text-gray-700 capitalize">type<span class="text-red-500">*</span></span>
      <select
        class="block w-full h-full px-4 py-2 pr-8 mb-6 leading-tight text-gray-700 bg-white border border-gray-400 rounded-l appearance-none focus:outline-none focus:bg-white focus:border-gray-500 text-sm"
        v-model="blog.type_id"
      >
        <option v-for="type in types" :key="type.id" :value="type.id" class="whitespace-nowrap">
          {{ type.name }}
        </option>
      </select>

      <div class="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none mt-6">
        <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
        </svg>
      </div>
    </div>

    <label v-if="blog.type_id === 1 || blog.type_id === 2" class="block">
      <span class="text-sm text-gray-700 capitalize">thumbnail image<span class="text-red-500">*</span></span>
      <input
        type="file"
        class="block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        @change="handleThumbanilImageUpload"
        accept="image/*"
      />
    </label>
    <img
      v-if="(blog.type_id === 1 || blog.type_id === 2) && blog.thumbnail_image"
      :src="thumbnailImage"
      alt="Thumbnail Preview"
      class="mt-2 mx-auto w-1/3 h-48 object-cover rounded-md"
    />

    <label v-if="blog.type_id === 2" class="block">
      <span class="text-sm text-gray-700 capitalize">banner video<span class="text-red-500">*</span></span>
      <input
        type="file"
        class="block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        @change="handleBannerVideoUpload"
        accept="video/*"
      />
    </label>
    <video v-if="blog.banner_video && blog.type_id === 2" controls class="mb-4 mx-auto w-1/3 h-56 object-cover" :poster="thumbnailImage">
      <source :src="bannerVideo" type="video/mp4" />
    </video>

    <label v-if="blog.type_id === 3" class="block">
      <span class="text-sm text-gray-700 capitalize">carousel images<span class="text-red-500">*</span></span>
      <input
        type="file"
        multiple
        class="block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        @change="handleCarouselImageUpload"
        accept="image/*,video/*"
      />
    </label>
    <div v-if="blog.type_id === 3" class="flex flex-wrap w-full gap-2 mb-2">
      <span v-for="(item, index) in blog.carousel" :key="item.previewUrl" class="relative">
        <video v-if="isVideo(item)" controls class="w-full h-48 object-cover rounded-md mb-2 border">
          <source :src="item?.previewUrl ? item?.previewUrl : item" :type="item.file.type" />
        </video>
        <img v-else :src="item?.previewUrl ? item?.previewUrl : item" alt="Carousel Preview" class="w-full h-48 object-cover rounded-md mb-2 border" />
        <button @click="removeCarouselItem(index)" class="absolute top-1 right-1 px-2 bg-red-500 text-white rounded-full">x</button>
      </span>
    </div>

    <label class="block">
      <span class="text-sm text-gray-700 capitalize">seo title<span class="text-red-500">*</span></span>
      <input
        type="text"
        class="block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        v-model="blog.seo_title"
      />
    </label>

    <label class="block">
      <span class="text-sm text-gray-700 capitalize">seo description<span class="text-red-500">*</span></span>
      <input
        type="text"
        class="block w-full h-12 mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        v-model="blog.seo_description"
      />
    </label>

    <label class="block">
      <span class="text-sm text-gray-700 capitalize">canonical tag<span class="text-red-500">*</span></span>
      <input
        type="text"
        class="block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        v-model="blog.canonical_tag"
      />
    </label>

    <label class="block">
      <span class="text-sm text-gray-700 capitalize">notes</span>
      <input
        type="text"
        class="block w-full mt-1 mb-6 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        v-model="blog.notes"
      />
    </label>

    <label class="block">
      <span class="text-sm text-gray-700 capitalize">tags<span class="text-red-500">*</span></span>
      <div v-if="blog.tags != ''" class="flex flex-wrap gap-2 mb-2">
        <span v-for="(tag, index) in (blog.tags || '').split(',').filter((t) => t.trim())" :key="index">
          <div v-if="tag != ''" class="px-2 py-1 bg-gray-200 rounded-md text-sm flex items-center">
            {{ tag }}
            <button class="ml-1 text-red-500">
              <svg
                @click="removeTag(index)"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
                width="15"
                height="15"
              >
                <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </button>
          </div>
        </span>
      </div>
      <input
        type="text"
        v-model="newTag"
        class="block w-full mt-1 mb-1 border px-4 py-2 border-gray-400 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 text-sm"
        @keydown.enter.prevent="addTag"
      />
      <p class="text-xs text-gray-500">Press Enter to add the tag</p>
    </label>
    <!--Footer-->
    <div class="flex justify-end items-center pt-2 relative">
      <button @click="clearForm" class="p-3 px-6 py-3 mr-2 text-indigo-500 bg-transparent rounded-lg hover:bg-gray-100 hover:text-indigo-400 focus:outline-none">Clear</button>
      <button @click="handleSubmit" type="submit" class="px-6 py-3 font-medium tracking-wide text-white bg-indigo-600 rounded-md hover:bg-indigo-500 focus:outline-none">
        {{ isSubmitting ? "Submitting" : "Submit to review" }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import axios from "axios";
import Swal from "sweetalert2";
const baseUrl = process.env.VUE_APP_BASE_URL;
import Editor from "@tinymce/tinymce-vue";

const blog = ref({
  title: "",
  slug: "",
  subtitle: "",
  category_id: "",
  body: "",
  type_id: "",
  thumbnail_image: "",
  banner_video: "",
  seo_title: "",
  seo_description: "",
  canonical_tag: "",
  status_id: 1,
  created_by: "",
  approved_by: "",
  published_at: "",
  views: 0,
  notes: "",
  tags: "",
  carousel: [],
});
const newTag = ref("");
const { categories, types } = defineProps({
  categories: {
    type: Array,
    required: true,
  },
  types: {
    type: Array,
    required: true,
  },
});
const thumbnailImage = ref(null);
const bannerVideo = ref(null);
const isSubmitting = ref(false);
const carousel_image_previews = ref([]);
const content = ref("");

// temporary
const isContentCopyPasted = ref(false);

const handleSubmit = async () => {
  // set the content to the blog body
  blog.value.body = content.value;

  //check for mandatory fields
  if (!blog.value.title || !blog.value.slug || !blog.value.subtitle || !blog.value.category_id || !blog.value.body || !blog.value.type_id || !blog.value.status_id) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please fill all mandatory fields!",
    });
    return;
  }

  if (blog.value.type_id === 1 && !blog.value.thumbnail_image) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please upload a thumbnail image!",
    });
    return;
  }
  if (blog.value.type_id === 2 && (!blog.value.banner_video || !blog.value.thumbnail_image)) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please upload a thumbnail image and a banner video!",
    });
    return;
  }
  if (blog.value.type_id === 3 && blog.value.carousel.length === 0) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please upload at least one carousel image!",
    });
    return;
  }

  // check tags are empty or not
  if (blog.value.tags === "") {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Please add at least one tag!",
    });
    return;
  }

  try {
    isSubmitting.value = true;
    const formData = new FormData();

    for (const key in blog.value) {
      if (key === "carousel") {
        if (blog.value.carousel && blog.value.carousel.length > 0) {
          blog.value.carousel.forEach((file, index) => {
            formData.append(`carousel[${index}]`, file.file);
          });
        }
      } else {
        formData.append(key, blog.value[key]);
      }
    }

    // formData.forEach((value, key) => {
    //     console.log(key + ': ' + value);
    // });

    const token = localStorage.getItem("token");
    const response = await axios.post(`${baseUrl}/blog/store`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    isSubmitting.value = false;
    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Blog created successfully!",
    });
  } catch (error) {
    console.error(error);
    isSubmitting.value = false;
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "There are some issues with the content. Please try again!",
    });
  }
};

const clearForm = () => {
  blog.value = {
    title: "",
    slug: "",
    subtitle: "",
    category_id: "",
    body: "",
    type_id: "",
    thumbnail_image: "",
    banner_video: "",
    seo_title: "",
    seo_description: "",
    canonical_tag: "",
    status_id: "",
    created_by: "",
    approved_by: "",
    published_at: "",
    views: "",
    notes: "",
    tags: "",
    carousel: [],
  };
};

const addTag = () => {
  if (newTag.value.trim() === "") {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Tag cannot be empty!",
    });
    return;
  }

  const tagsArray = blog.value.tags ? blog.value.tags.split(",") : [];
  tagsArray.push(newTag.value.trim());
  blog.value.tags = tagsArray.join(", ");

  newTag.value = ""; // Clear input field
};

const removeTag = (index) => {
  let tagsArray = blog.value.tags.split(",");
  tagsArray.splice(index, 1);
  blog.value.tags = tagsArray.join(", ");
};

const handleThumbanilImageUpload = (event) => {
  const file = event.target.files[0]; // Get the selected file
  if (file) {
    blog.value.thumbnail_image = file;

    // Generate a preview URL
    thumbnailImage.value = URL.createObjectURL(file);
  }
};

const handleBannerVideoUpload = (event) => {
  const file = event.target.files[0]; // Get the selected file
  if (file) {
    blog.value.banner_video = file;

    // Generate a preview URL
    bannerVideo.value = URL.createObjectURL(file);
  }
};

const handleCarouselImageUpload = (event) => {
  const newFiles = event.target.files;

  if (newFiles.length > 0) {
    Array.from(newFiles).forEach((file) => {
      blog.value.carousel.push({
        file: file,
        previewUrl: URL.createObjectURL(file),
      });
    });
  }

  event.target.value = null;
};

const onPaste = () => {
  // Swal.fire({
  //   icon: "warning",
  //   title: "Paste is disabled",
  //   text: "You cannot paste content into this editor.",
  // });
  isContentCopyPasted.value = true;
};

const tinyMceImageUploader = (blobInfo, progress) =>
  new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", blobInfo.blob(), blobInfo.filename());

    const uploadUrl = `${baseUrl}/content/upload`;

    fetch(uploadUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        progress(100);

        if (!response.ok) {
          return response
            .json()
            .then((err) => {
              throw new Error(err.message || `HTTP error! status: ${response.status}`);
            })
            .catch(() => {
              throw new Error(`HTTP error! status: ${response.status}`);
            });
        }
        return response.json();
      })
      .then((data) => {
        if (data.success && data.data && data.data.file_path) {
          resolve(data.data.file_path);
        } else {
          const errorMessage = data.message || "Server did not return a valid image URL or success status.";
          console.error("Image upload failed:", errorMessage, data);
          reject(errorMessage);
        }
      })
      .catch((error) => {
        console.error("Image upload failed:", error);
        reject(`Image upload failed: ${error.message || error}`);
      });
  });

const isVideo = (item) => {
  if (item && item.file && item.file.type) {
    return item.file.type.startsWith("video/");
  }

  if (typeof item === "string" && item.match(/\.(mp4|webm|ogg)$/)) {
    return true;
  }

  if (typeof item === "string" && item.startsWith("http")) {
    const url = new URL(item);
    return url.pathname.endsWith(".mp4") || url.pathname.endsWith(".webm") || url.pathname.endsWith(".ogg");
  }
  return false;
};

const removeCarouselItem = (index) => {
  const itemToRemove = blog.value.carousel[index];
  if (itemToRemove && itemToRemove.previewUrl) {
    URL.revokeObjectURL(itemToRemove.previewUrl);
  }
  blog.value.carousel.splice(index, 1);
};
</script>

<style>
.modal {
  transition: opacity 0.25s ease;
}
.ql-editor {
  min-height: 300px;
}
.ql-toolbar .ql-picker.ql-expanded .ql-picker-options {
  z-index: 9999;
}

@media (min-width: 1024px) {
  #sample {
    display: flex;
    flex-direction: column;
    place-items: left;
    width: 100%;
  }
}
</style>
